import React, { useState } from 'react';
import { Grid, Button, Select, MenuItem, InputLabel } from '@mui/material';
import { Alert } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { LabelLine } from 'components/InputV2/components';
import { ButtonLoading, BusinessList } from 'components';
import { makeStyles } from '@mui/styles';
import { businessGrantPermission as businessGrantPermissionService } from '../../../../../../Business/services/BusinessServices';
import createToast from 'components/Toast/Toast';

const useStyles = makeStyles((theme) => ({
  cardActions: {},
  button: {
    minWidth: '125px',
  },
  buttonCancle: {
    minWidth: '125px',
  },
  alias: {
    marginTop: 0,
  },
  hint: {
    fontSize: 13,
    fontWeight: 'normal',
    color: '#1b3958',
  },
  viewSiteButton: {},
  label: {
    fontSize: '13px',
    color: '#455a64',
    marginBottom: 6,
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, -2px) scale(1)',
      },
    },
  },
}));

const BusinessGrantPermission = (props) => {
  const { onClose, guildCode } = props;
  const classes = useStyles();
  const { control, handleSubmit, formState: { errors } } = useForm();
  const [loadBtn, setLoadBtn] = useState(false);
  const [operationCode, setOperationCode] = useState('FINANCIAL_OPERATION_INVOICE');
  const navigate = useNavigate();

  const onSubmit = (data) => {
    setLoadBtn(true);

    async function grantPermissionForBusiness(params) {
      try {
        await businessGrantPermissionService(params);

        createToast('موفق', 'اعطای مجوز با موفقیت انجام شد.', 'success');

        onClose();
        navigate('/grant-permission/list');
      } catch (error) {}

      setLoadBtn(false);
    }

    grantPermissionForBusiness({
      grantedUserId: data.grantedUserId.userId,
      operationCode,
      guildCode,
    });
  };

  // const hint = 'از لیست كسب و كار های موجود كسب و كار مورد نظر خود را انتخاب کنید.';

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container spacing={4}>
          <Grid xs={12} item>
            <Alert severity="warning">
              <h3 className={classes.title}>توجه</h3>
              <div className={classes.textWrapper}>
                در پلتفرم کسب وکار، از طریق ایجاد مجوز برای کسب وکار دیگر، این امکان وجود دارد که آن
                کسب وکار دسترسی انجام عملیات مالی از جمله: کلیه عملیات مربوط به فاکتور، انتقال وجه،
                درخواست تسویه حساب، درخواست موجودی و درخواست صورتحساب مورد نظر را بر روی کسب وکار
                شما داشته باشد. برای ایجاد چنین مجوزی شما به عنوان کسب و کار اعطا کننده مجوز،
                میتوانید این مجوز را برای کسب و کار مورد نظر خود صادر کنید.
              </div>
            </Alert>
          </Grid>

          <Grid item xs={12}>
            <BusinessList
              label="كسب و كار مورد نظر خود را جستجو و انتخاب کنید"
              name="grantedUserId"
              errors={errors}
              control={control}
              required={true}
            />
          </Grid>

          <Grid item xs={12}>
            <InputLabel shrink className={classes.label}>
              <LabelLine label="انتخاب عملیات مالی برای اعطای مجوز" />
            </InputLabel>
            <Select
              fullWidth
              value={operationCode}
              onChange={(e) => {
                setOperationCode(e.target.value);
              }}
              variant="outlined"
              required={true}
              style={{ height: 38 }}
              className='pureSelect'
            >
              <MenuItem value="FINANCIAL_OPERATION_INVOICE">فاکتور</MenuItem>
              <MenuItem value="FINANCIAL_OPERATION_TRANSFER">انتقال وجه</MenuItem>
              <MenuItem value="FINANCIAL_OPERATION_REQUEST_SETTLEMENT">تسویه حساب</MenuItem>
              <MenuItem value="FINANCIAL_OPERATION_GET_CREDIT">موجودی حساب</MenuItem>
              <MenuItem value="FINANCIAL_OPERATION_ACCOUNT_BILL">صورتحساب</MenuItem>
            </Select>
          </Grid>

          <Grid item xs={12} className={classes.cardActions}>
            <ButtonLoading
              type="submit"
              color="primary"
              variant="contained"
              className={classes.button}
              loading={loadBtn}
              name="اعطای مجوز"
            />
            <Button variant="contained" onClick={() => onClose()} style={{ marginInlineStart: 10 }}>
              انصراف
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default BusinessGrantPermission;
